import React, { memo } from "react";
import ReactApexChart from "react-apexcharts";
import Spinner from "../spinner";

const ColumnChart = (props) => {
  const { series, categories, darkMode, loading = false } = props;
  const settings = {
    series,
    options: {
      theme: {
        mode: darkMode ? "dark" : "light",
      },
      chart: {
        height: 350,
        type: "bar",
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%";
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },

      xaxis: {
        categories,
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val + "%";
          },
        },
      },
      title: {
        show: false,
      },
    },
  };

  return (
    <div id="chart">
      {loading && <Spinner />}
      <ReactApexChart
        options={settings.options}
        series={settings.series}
        type="bar"
        height={450}
      />
    </div>
  );
};

export default memo(ColumnChart);
